import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import qs from 'query-string';
import { useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

import WebGalleryActionBar from '../../../../components/WebGalleryActionBar';
import WebGalleryAlbumRouteSelector from '../WebGalleryAlbumRouteSelector/WebGalleryAlbumRouteSelector';
import AlbumsIcon from '../../../../../../components/icons/AlbumsIcon';
import AlbumPhotoGroupIcon from '../../../../../../components/icons/AlbumPhotoGroupIcon';
import { setBreadcrumbNavigationState } from '../../../../redux/layout/webGalleryLayoutActions';
import NavigationBreadcrumbs from '../../../../../../components/global/NavigationBreadcrumbs';
import { prependAccountSlug } from '../../../../../../util/account';
import { getWebGalleryEntityPath } from '../../../../utilities/web-galleries';

const propTypes = {
  photoGroup: PropTypes.shape({
    id: PropTypes.string,
  }),
  album: PropTypes.shape({
    id: PropTypes.string,
  }).isRequired,
};

const WebGalleryAlbumNavigationlessHeader = ({ photoGroup, album }) => {
  const location = useLocation();
  const { navigationEnabled: locationNavigationEnabled } = qs.parse(
    location?.search,
  );
  const { breadcrumbNavigationEnabled } = useSelector(
    state => state.galleries.layout,
  );
  const dispatch = useDispatch();
  const onSetBreadcrumbNavigationState = useCallback(
    enabled => dispatch(setBreadcrumbNavigationState(enabled)),
    [dispatch],
  );

  useEffect(() => {
    if (location?.search && locationNavigationEnabled === 'false') {
      onSetBreadcrumbNavigationState(false);
    }
  }, [location?.search]);

  return (
    <>
      {breadcrumbNavigationEnabled ? (
        <>
          <WebGalleryActionBar albumPhotoGroup={photoGroup} album={album} />
          <div className="px-sm-2 px-md-5 px-0">
            <WebGalleryAlbumRouteSelector
              album={album}
              albumPhotoGroup={photoGroup}
            />
          </div>
        </>
      ) : (
        <div className="wg-gallery-action-bar">
          <div className="wg-gallery-title-breadcrumb">
            {photoGroup && (
              <NavigationBreadcrumbs
                trail={[
                  {
                    label: album.name,
                    path: prependAccountSlug(
                      getWebGalleryEntityPath(album),
                      album,
                    ),
                  },
                ]}
                maxCrumbs={4}
                breakpoint="md"
                mobileMaxCrumbs={1}
              />
            )}
            <div className="web-gallery-nav-title">
              {photoGroup ? (
                <>
                  <AlbumPhotoGroupIcon color="#1a2e34" />
                  <h2 className="mb-0">{photoGroup.name}</h2>
                </>
              ) : (
                <>
                  <AlbumsIcon color="#1a2e34" />
                  <h2 className="mb-0">{album.name}</h2>
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

WebGalleryAlbumNavigationlessHeader.propTypes = propTypes;

export default WebGalleryAlbumNavigationlessHeader;
